// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"8ac96b67","950":"40c10ba3"}[chunkId] + ".chunk.js";
};